/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sign_In_1Inputs */

const en_sign_in_1 = /** @type {(inputs: Sign_In_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in`)
};

const es_sign_in_1 = /** @type {(inputs: Sign_In_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar sesión`)
};

const fr_sign_in_1 = /** @type {(inputs: Sign_In_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se connecter`)
};

const de_sign_in_1 = /** @type {(inputs: Sign_In_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmelden`)
};

const ja_sign_in_1 = /** @type {(inputs: Sign_In_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ログイン`)
};

const zh_sign_in_1 = /** @type {(inputs: Sign_In_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录`)
};

const ar_sign_in_1 = /** @type {(inputs: Sign_In_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تسجيل الدخول`)
};

const id_sign_in_1 = /** @type {(inputs: Sign_In_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masuk`)
};

const it_sign_in_1 = /** @type {(inputs: Sign_In_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accedi`)
};

const ru_sign_in_1 = /** @type {(inputs: Sign_In_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Войти`)
};

const pt_sign_in_1 = /** @type {(inputs: Sign_In_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrar`)
};

const ko_sign_in_1 = /** @type {(inputs: Sign_In_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로그인`)
};

/**
* | output |
* | --- |
* | "Sign in" |
*
* @param {Sign_In_1Inputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const sign_in_1 = /** @type {((inputs?: Sign_In_1Inputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sign_In_1Inputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sign_in_1(inputs)
	if (locale === "es") return es_sign_in_1(inputs)
	if (locale === "fr") return fr_sign_in_1(inputs)
	if (locale === "de") return de_sign_in_1(inputs)
	if (locale === "ja") return ja_sign_in_1(inputs)
	if (locale === "zh") return zh_sign_in_1(inputs)
	if (locale === "ar") return ar_sign_in_1(inputs)
	if (locale === "id") return id_sign_in_1(inputs)
	if (locale === "it") return it_sign_in_1(inputs)
	if (locale === "ru") return ru_sign_in_1(inputs)
	if (locale === "pt") return pt_sign_in_1(inputs)
	return ko_sign_in_1(inputs)
});